import React, { useState, useEffect, Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  setClientBranchSearchAction,
  getRoleListActions,
  gettheoverallOnboaderDatas,
  gettheStoretheRejoiningActions,
} from "../../../Redux/Slice";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import Button from "@mui/material/Button";
import PlusIcon from "../../../Assets/AppComponent/Asset 9.svg";
import minus from "../../../Assets/AppComponent/Asset 10.svg";
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";
import { toast } from "react-toastify";

export const Rejoining = () => {
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const [nameList4, setOptions4] = useState([]);
  const [searchBranch, setSearch] = useState("");
  const dispatch = useDispatch();
  const [ClientValues, setclientValues] = useState();
  const [RoleOPtions, setRoleOPtions] = useState();
  const [rolesearch, setrolesearch] = useState("");
  const [roleValues, setRoleValues] = useState();
  const [Onboarderoptions, setonboarderoptions] = useState();
  const [OnboarderValues, setonboarderValue] = useState();
  const [remarkserror, setremarkserr] = useState("");
  const [inputFields, setInputFields] = useState([
    {
      Files: "",
      file: "",
    },
  ]);
  const [PresentUrls, setPresentUrls] = useState([]);
  const [url, setUrl] = useState();
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [images, setImages] = useState([]);
  const [forindex, setforindex] = useState();
  const [updated, setupdatefile] = useState(false);
  const [imagesFile, setImagesFile] = useState([]);
  const [imageFileChange, setImageFileChange] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [imageFiles, setImageFiles] = useState();

  const [documentPassed, setdocumentPassed] = useState(false);
  const updateAvatar = (imgSrc) => {
    fileInputRef.current = imgSrc;
  };
  const [imgsrc, setImgsrc] = useState();
  const fileInputRef = useRef();
  const navigate = useNavigate();
  const initialState = {
    user_id: state.EmployeeProfile.EmployeeProfileList.user_id?.id,
    name: state.EmployeeProfile.EmployeeProfileList.user_id?.first_name,
    remarks: "",
    client: "",
    role_id: "",
    zone_id: "",
    current_onboarder: "",
  };
  const [data, setdata] = useState(initialState);
  const [remarkserr, steremarkserr] = useState("");
  const [onboadersearch, setonboardersearch] = useState("");
  const [onboarder_err, setonboarder_err] = useState("");
  const [client_err, setclient_err] = useState("");
  const [designation_err, setdesignation_err] = useState("");

  useEffect(() => {
    const datas = {
      state: "",
      region: "",
      zone: "",
    };
    const payload = {
      search: searchBranch,
      page_size: 30,
      page: 1,
      data: datas,
    };
    dispatch(setClientBranchSearchAction(payload));
  }, [searchBranch]);

  useEffect(() => {
    if (data.zone_id != "") {
      console.log(data, "dkjasjkdajksdkjakjj");
      const payload = {
        zone: data.zone_id,
        client: data?.client,
        for_rejoining: true,
        search: onboadersearch,
      };
      dispatch(gettheoverallOnboaderDatas(payload));
    }
  }, [data.zone_id, onboadersearch]);

  useEffect(() => {
    const payloads = {
      search: rolesearch,
      page_size: "",
      page: 1,
      mode: "all",
      client: data.client,
      white_collar: false,
      month: "",
      year: "",
    };
    dispatch(getRoleListActions(payloads));
  }, [rolesearch, data.client]);

  const HandleInputBranch = (e) => {
    setSearch(e);
  };
  const HandleRoleAPi = (e) => {
    setrolesearch(e);
  };
  const HandleChanges = (e, valuess) => {
    const { name, value } = e.target;

    setdata({
      ...data,
      [name]: value,
    });
  };
  const HandleClientBranches = (selectedVal) => {
    if (selectedVal != null) {
      setdata({
        ...data,
        client: selectedVal.value,
        zone_id: selectedVal.zone,
        role_id: "",
        current_onboarder: "",
      });
      setclientValues(selectedVal);
      setRoleValues({});
      setonboarderValue({});
    } else if (selectedVal == null) {
      setdata({
        ...data,
        client: "",
        zone_id: "",
        role_id: "",
        current_onboarder: "",
      });
      setclientValues();
      setRoleValues({});
      setonboarderValue({});
    }
  };
  const handelRoleIdForExports = (e) => {
    if (e != null) {
      setRoleValues(e);
      setdata({
        ...data,
        role_id: e.value,
      });
    } else if (e == null) {
      setRoleValues({});
      setdata({
        ...data,
        role_id: "",
      });
    }
  };

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
          zone: element.zone_id.id,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, searchBranch]);
  useEffect(() => {
    if (state.OnboarderRejoindata.RejoiningonboaderData != undefined) {
      let objectArray = [];
      state.OnboarderRejoindata.RejoiningonboaderData.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.first_name.toUpperCase(),
        });
      });
      setonboarderoptions(objectArray);
    }
  }, [state.OnboarderRejoindata.RejoiningonboaderData, onboadersearch]);

  useEffect(() => {
    if (state.rolelists.RoleList != undefined) {
      let objectArray = [];
      state.rolelists.RoleList.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.role.toUpperCase(),
        });
      });

      setRoleOPtions(objectArray);
    }
  }, [state.rolelists.RoleList, rolesearch]);
  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = "";
      return newImages;
    });
    setInputFields(values);
    const updatedImagesFile = [...imagesFile];

    updatedImagesFile[index] = "";
    setImagesFile(updatedImagesFile);
  };
  const handleAddFields = (index) => {
    if (inputFields.length != 10) {
      const values = [...inputFields];
      values.push({
        Files: "",
        file: "",
      });

      setInputFields(values);
      setImages((prevImages) => {
        const newImages = [...prevImages];
        newImages[index] = "";
        return newImages;
      });
    }
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];

    if (event.target.name === "file") {
      setalert(true);
      // images.map((item)=>{
      //   values[index].Files = item;
      // })
      setImageFiles(event);
      //console.log(event.target.files[0], "evefasfsdl");
      setCroppImageViewCount(index);
      setCroppImageView(true);
      setupdatefile(true);

      const file = event.target.files[0];
      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      const MIN_DIMENSION = 150;

      if (file && allowedTypes.includes(file.type)) {
        if (file.size > maxSize) {
          setCroppImageView(false);
          toast.error("File size exceeds 10MB. Please upload a smaller image.");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (imgEvent) => {
              const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

              if (
                naturalWidth < MIN_DIMENSION ||
                naturalHeight < MIN_DIMENSION
              ) {
                toast.error("Image must be at least 150 x 150 pixels.");
                setCroppImageView(false);
                return;
              }
              selectedImage(event, index);
            });
          });
          reader.readAsDataURL(file); // Read the file as a data URL
        }
      } else {
        setCroppImageView(false);
        toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      }
    }

    setInputFields(values);
  };
  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        var file = croppedFile;
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false);
          }, 0);
        }
        setImageFileChange((prevState) => {
          const newState = [...prevState];
          newState[forindex] = true;
          return newState;
        });

        const valuesFile = [...inputFields]; ///file
        valuesFile[forindex].file = croppedFile; // Assuming you have a field for croppedImageData
        setInputFields(valuesFile);
        const generateRandomNumber = (digits = 12) => {
          const min = 10 ** (digits - 1);
          const max = 10 ** digits;
          return Math.floor(min + Math.random() * (max - min));
        };
        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/rejoining_support_doc/cropped${randomNumber}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };

          return Presentdata;
        };

        const Presentdata = createPresentData(croppedFile);

        setupdatefile(true);

        axios({
          url: PresentUrl,
          method: "post",
          data: Presentdata,
          headers: {
            Authorization:
              "Bearer " + store.getState().users.UserData.session.token,
          },
        })
          .then((response) => {
            console.log("Files uploaded successfully:", response.data);
            const uploadedFiles = response.data.data;

            const newUrls = uploadedFiles.map((file) => ({
              url: file,
              type: croppedFile.type,
              putfiles: croppedFile,
            }));
            setPresentUrls((prevUrls) => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = newUrls[0];
              return updatedUrls;
            });

            const updatedImageUrl = String(response.data.data).split("?")[0];
            const values = [...inputFields]; ///----result
            values[forindex].certificate = String(response.data.data).split(
              "?",
            )[0];
            setInputFields(values);

            setImagesFile((prevUrls) => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = String(response.data.data).split("?")[0];
              return updatedUrls;
            });
          })
          .catch((error) => {
            console.error("Error uploading files:", error);
          });

        setdocumentPassed(true);

        var fileBase = croppedFile;
        var reader = new FileReader();
        reader.onloadend = function () {
          setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[forindex] = reader.result;
            return newImages;
          });
          const values = [...inputFields];
          values[forindex].Files = reader.result;
          setInputFields(values);

          console.log(inputFields, "inputFields");
        };
        reader.readAsDataURL(fileBase);
        //  }

        blob.name = fileName;
        resolve(croppedFile);
      }, "image/jpeg");
    });
  }
  const handleFiles = (e) => {
    selectedImage(e);
  };
  const selectedImage = (e) => {
    console.log(e.target.files[0], "e.target.files[0]");
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };
  const handleOnboarder = (selectedVal) => {
    if (selectedVal != null) {
      setdata({
        ...data,
        current_onboarder: selectedVal.value,
      });
      setonboarderValue(selectedVal);
    } else if (selectedVal == null) {
      setdata({
        ...data,
        current_onboarder: "",
      });
      setonboarderValue({});
    }
  };

  const HandleSubmit = () => {
    var a = 0;
    if (data.remarks == "") {
      setremarkserr("*Remarks is requried");
      a = 1;
    }
    if (data.current_onboarder == "") {
      setonboarder_err("*Onboarder is requried");
      a = 1;
    }
    if (data.client == "") {
      setclient_err("*Client is requried");
      a = 1;
    }
    if (data.role_id == "") {
      setdesignation_err("*Designation is requried");
      a = 1;
    }

    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item, index) => {
          try {
            if (item != undefined && item != null) {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });

              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }

              if (PresentUrls.length == index + 1) {
                let EditedDATAPresent = {
                  remarks: data.remarks,
                  user_id:
                    state.EmployeeProfile.EmployeeProfileList.user_id?.id,
                  current_client: data.client,
                  current_role: data.role_id,
                  current_onboarder: data.current_onboarder,
                };
                // imagesFile.forEach((element, index) => {
                //     if (element != null && element != undefined && element != "") {
                //         EditedDATAPresent = {
                //             ...EditedDATAPresent,

                //             [`document${index}`]: element

                //         }
                //     }

                // });
                let documentIndex = 0;
                imagesFile.forEach((element) => {
                  // Check if the element is valid (not null, undefined, or an empty string).
                  if (
                    element !== null &&
                    element !== undefined &&
                    element !== ""
                  ) {
                    EditedDATAPresent[`document${documentIndex}`] = element;
                    documentIndex++; // Increment the index only for valid elements
                  }
                });

                const payload = {
                  formdatas: EditedDATAPresent,
                  API: 2,

                  Funcations: () => {
                    navigate("/employeeprofile");
                  },
                };
                dispatch(gettheStoretheRejoiningActions(payload));
                setPresentUrls([]);
              }
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }),
      );
    };

    if (documentPassed == true && a == 0) {
      fetchUploadFiles();
    } else if (documentPassed == false && a == 0) {
      const payload = {
        formdatas: {
          remarks: data.remarks,
          user_id: state.EmployeeProfile.EmployeeProfileList.user_id?.id,
          current_client: data.client,
          current_role: data.role_id,
          current_onboarder: data.current_onboarder,
        },
        API: 2,

        Funcations: () => {
          navigate("/employeeprofile");
        },
      };
      dispatch(gettheStoretheRejoiningActions(payload));
    }
  };
  console.log(data, "sduapsdidata");

  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Rejoin</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => navigate("/employeeprofile")}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ width: "315px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Employee
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={
                              state.EmployeeProfile.EmployeeProfileList.user_id
                                .first_name
                            }
                            name="name"
                            readOnly
                            disabled
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                          >
                            Client
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              HandleClientBranches(e);
                              setclient_err("");
                            }}
                            options={nameList4}
                            labelledBy="Select"
                            onInputChange={HandleInputBranch}
                            isClearable={true}
                            value={ClientValues}
                          />
                          <p className="Error">{client_err}</p>
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                          >
                            Designation
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            options={RoleOPtions}
                            labelledBy="Select"
                            onInputChange={HandleRoleAPi}
                            isClearable={true}
                            value={roleValues}
                            onChange={(e) => {
                              handelRoleIdForExports(e);
                              setdesignation_err("");
                            }}
                          />
                          <p className="Error">{designation_err}</p>
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                          >
                            Onboarder
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            options={Onboarderoptions}
                            labelledBy="Select"
                            isClearable={true}
                            value={OnboarderValues}
                            onChange={(e) => {
                              handleOnboarder(e);
                              setonboarder_err("");
                            }}
                            onInputChange={(e) => setonboardersearch(e)}
                          />
                          <p className="Error">{onboarder_err}</p>
                        </div>

                        <div className="col-sm-3  mt-1 mb-4">
                          <label for="validationCustom01" class="form-label">
                            Remarks
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.remarks}
                            name="remarks"
                            onChange={(e) => {
                              HandleChanges(e);
                              setremarkserr("");
                            }}
                          />
                          <p className="Error">{remarkserror}</p>
                        </div>

                        {/* <div className="col-sm-7 mt-3 Documentfiled">
                                                    <label
                                                        for="validationCustom01"
                                                        class="form-label"
                                                        style={{ width: "100%" }}
                                                    >
                                                        Documents
                                                    </label>

                                                    {inputFields.map((inputField, index) => {
                                                        return (
                                                            <Fragment key={`${inputField}~${index}`}>
                                                                <div
                                                                    className="form-group col-sm-12"
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                    }}
                                                                >
                                                                    <div
                                                                        className=" btn  StatusList"
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-end",
                                                                            alignContent: "center",
                                                                            gap: "20px",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className="DeclineStatus"
                                                                            disabled={index === 0}
                                                                            onClick={() => {
                                                                                handleRemoveFields(index);
                                                                            }}
                                                                        >
                                                                            <span>
                                                                                <img src={minus} />
                                                                            </span>                                    </button>

                                                                        <div
                                                                            className="AddingButton"
                                                                            onClick={(index) => {
                                                                                handleAddFields(index);
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: "#F58837",
                                                                                fontSize: "19px",
                                                                                width: "  20px",
                                                                                height: "20px ",
                                                                                borderRadius: "50%",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            <span className="PlusButton">
                                                                                <img src={PlusIcon} />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    className="col-12"
                                                                    style={{ paddingLeft: "25px" }}
                                                                >


                                                                    <div
                                                                        className="col-12"
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-start",
                                                                            alignItems: "flex-start",
                                                                            gap: "10px",
                                                                            flexDirection: "column",
                                                                        }}
                                                                    >
                                                                        {inputField.Files &&
                                                                            <img
                                                                                // src={images[0]}
                                                                                src={inputField.Files}
                                                                                style={{
                                                                                    width: "150px",
                                                                                    height: "150px",
                                                                                    border: "1px solid #000",
                                                                                    borderRadius: "10px",
                                                                                }}
                                                                            />
                                                                        }

                                                                        <Button
                                                                            className="doctorupload"
                                                                            variant="contained"
                                                                            component="label"
                                                                            style={{
                                                                                background: "#234492",
                                                                                color: "white",
                                                                            }}
                                                                        >

                                                                            <input
                                                                                type="file"
                                                                                hidden
                                                                                accept="image/png, image/jpeg"
                                                                                name="file"
                                                                                // onChange={(e) => handleFiles(e)}
                                                                                onChange={(event) => {
                                                                                    setforindex(index);
                                                                                    handleInputChange(index, event);
                                                                                }}
                                                                                ref={fileInputRef}

                                                                            />
                                                                            Upload Image
                                                                        </Button>
                                                                    </div>

                                                                </div>
                                                            </Fragment>
                                                        );
                                                    })}
                                                </div> */}

                        <div className="col-sm-12 Documentfiled mt-5">
                          <div style={{ display: "flex" }}>
                            <label
                              for="validationCustom01"
                              class="form-label"
                              style={{ width: "100%" }}
                            >
                              Documents
                            </label>
                          </div>

                          <div style={{ display: "flex" }}>
                            {inputFields.map((inputField, index) => {
                              return (
                                <Fragment key={`${inputField}~${index}`}>
                                  <div
                                    className="form-group "
                                    style={{
                                      display: "flex",
                                    }}
                                  >
                                    <div
                                      className=" btn  StatusList"
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignContent: "center",
                                        gap: "20px",
                                      }}
                                    >
                                      <div
                                        className="col-sm-7"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-start",
                                          alignItems: "flex-start",
                                          gap: "10px",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {inputField.Files && (
                                          <img
                                            // src={images[0]}
                                            src={inputField.Files}
                                            style={{
                                              width: "150px",
                                              height: "150px",
                                              border: "1px solid #000",
                                              borderRadius: "10px",
                                            }}
                                          />
                                        )}

                                        <Button
                                          className="doctorupload"
                                          variant="contained"
                                          component="label"
                                          style={{
                                            background: "#234492",
                                            color: "#fff",
                                            fontSize: "11px !important",
                                          }}
                                        >
                                          <input
                                            type="file"
                                            hidden
                                            accept="image/png, image/jpeg"
                                            name="file"
                                            // onChange={(e) => handleFiles(e)}
                                            onChange={(event) => {
                                              setforindex(index);
                                              handleInputChange(index, event);
                                            }}
                                            ref={fileInputRef}
                                          />
                                          Upload Image
                                        </Button>
                                      </div>

                                      <div
                                        className="col"
                                        style={{ display: "flex", gap: "19px" }}
                                      >
                                        <>
                                          <button
                                            className="DeclineStatus"
                                            disabled={index === 0}
                                            onClick={() => {
                                              handleRemoveFields(index);
                                            }}
                                          >
                                            <span>
                                              <img src={minus} />
                                            </span>
                                          </button>
                                          {index === 0 ? (
                                            <div
                                              className="AddingButton"
                                              onClick={() => {
                                                if (inputFields.length < 5) {
                                                  handleAddFields(index);
                                                }
                                              }}
                                              style={{
                                                backgroundColor: "#F58837",
                                                fontSize: "19px",
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor:
                                                  inputFields.length >= 5
                                                    ? "not-allowed"
                                                    : "pointer",
                                              }}
                                            >
                                              <span className="PlusButton">
                                                <img src={PlusIcon} alt="Add" />
                                              </span>
                                            </div>
                                          ) : null}
                                        </>
                                      </div>
                                    </div>
                                  </div>
                                </Fragment>
                              );
                            })}
                          </div>
                        </div>

                        <div
                          className="col-12 mt-5 RejoinSCSS"
                          style={{ marginTop: "20px" }}
                        >
                          <div>
                            <button
                              class="btn ButtonCSS"
                              style={{ background: "#234492b0" }}
                              onClick={(e) => navigate("/employeeprofile")}
                            >
                              Cancel
                            </button>
                            <button
                              class="btn  ButtonCSS"
                              type="submit"
                              style={{ background: "#234492" }}
                              onClick={(e) => {
                                HandleSubmit(e);
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={imageFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};
